import React from 'react';

import { MCButton, PopoverMenu, View } from 'src/components/basic';
import {
  rgba,
  scssVariables as variables,
  scssVariables,
  userFullName,
  withRouter
} from 'src/helpers';

import BaseMessage, { tabs, list } from 'src/components/messages';
import { remCss } from 'src/components/mobile/utils';
import { BASE_ICONS } from 'src/components/svg';
import ShortInfo from 'src/components/user/ShortInfo';
import { ActivityLabel } from 'src/components/user/LastActivity';
import Chat from 'src/components/messages/chat';
import analysesModel from 'src/components/messages/analysesModel';
import timelineModel from 'src/components/messages/timelineModel';
import treatmentsModel from 'src/components/messages/treatmentsModel';
import messagesModel from 'src/components/messages/model';
import chatModel from 'src/components/messages/chat/model';
import callModel from 'src/components/call/model';
import TreatmentsList from 'src/components/treatments/list';
import AnalysesList from 'src/components/analyse/list';
import TimelineList from 'src/components/timeline/list';
import Call from 'src/components/call';

export class Main extends BaseMessage {
  componentDidMount() {
    super.componentDidMount();
    messagesModel.on('auth', this.refreshAll);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    messagesModel.cancel('auth', this.refreshAll);
  }

  refreshAll = () => {
    const { contact } = chatModel.state;
    if (contact) {
      chatModel.setStateSilent({ contact: null });
      chatModel.onOpenContact({ contact });
      analysesModel.refresh();
      treatmentsModel.refresh();
      timelineModel.refresh();
    }
  };
  openRouteContact = () => {};

  renderHeader() {
    const { contactUser = {} } = messagesModel.state;
    const callUUID = callModel.state.current;
    const { isCaller, callerId } = callModel.getListState(callUUID);
    const isCalling = callUUID && (isCaller || callerId === contactUser?.id);
    return (
      <View>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: remCss(10),
            paddingHorizontal: remCss(15),
            paddingVertical: remCss(10),
            backgroundColor: 'white'
          }}
        >
          <MCButton
            iconname={BASE_ICONS.BACK_ARROW}
            onClick={this.props.onBack}
            width={remCss(50)}
            height={remCss(50)}
            padding={1}
          />
          <ShortInfo
            width={remCss(54)}
            user={contactUser}
            fullname={userFullName(contactUser, true)}
            description={
              <ActivityLabel
                accountState={contactUser?.accountState}
                lastActivity={contactUser?.lastActivity}
                connections={contactUser?.connections}
              />
            }
          />
          <MCButton
            iconname={BASE_ICONS.SEARCH}
            small
            fill={scssVariables['colors-mc-heading']}
            onClick={this.toggleSearch}
          />
          {!isCalling && (
            <MCButton
              iconname={BASE_ICONS.PHONE}
              small
              fill={scssVariables['colors-mc-heading']}
              onClick={this.startCall}
            />
          )}

          <PopoverMenu
            style={{ cursor: 'pointer' }}
            placement={'bottom-end'}
            arrowOffset={-90}
            menu={(close) => (
              <ul
                className={'mc-select-field-items'}
                style={{
                  backgroundColor: 'white',
                  padding: remCss(10)
                }}
              >
                {list
                  .filter((item) => item.isShow(contactUser, messagesModel.state.user))
                  .map((item) => (
                    <li
                      key={item.label}
                      onClick={() => {
                        if (item.onClick) {
                          item.onClick(contactUser);
                        } else {
                          this.setOption(item);
                        }
                        close();
                      }}
                    >
                      <div className={'mc-p15 mc-pointer'}>
                        <div className={'mc-value-520'}>{item.label}</div>
                      </div>
                    </li>
                  ))}
              </ul>
            )}
          >
            {() => (
              <MCButton
                iconname={BASE_ICONS.DOTS}
                small
                fill={scssVariables['colors-mc-heading']}
              />
            )}
          </PopoverMenu>
        </View>
        {isCalling && <Call />}
        {messagesModel.state.enableSearch ? (
          <View style={{ padding: remCss(10) }}>{this.renderSearchMessage()}</View>
        ) : !isCalling && contactUser ? (
          <View
            style={{
              paddingTop: remCss(10),
              flexDirection: 'row',
              backgroundColor: rgba(scssVariables['colors-mc-primary'], 0.1),
              paddingHorizontal: remCss(10),
              justifyContent: 'space-between'
            }}
          >
            {tabs.map((m) => {
              const active = m.id === messagesModel.getTab('main_message');
              return (
                <MCButton
                  style={{
                    paddingVertical: remCss(15),
                    transition: 'all 0.2s ease',
                    borderTop: `${remCss(2)}px solid transparent`,
                    ...(active
                      ? {
                          borderTop: `${remCss(2)}px solid ${variables['colors-mc-primary']}`
                        }
                      : {})
                  }}
                  label={m.name}
                  key={m.id}
                  flex
                  small
                  transparent={!active}
                  primary={active}
                  tertiary={!active}
                  onClick={() => messagesModel.changeMessageTab(m)}
                />
              );
            })}
          </View>
        ) : (
          <div className={'mc-line'} />
        )}
      </View>
    );
  }

  render() {
    const tab = messagesModel.getTab('main_message');
    return (
      <View
        style={{
          height: '100%',
          backgroundColor: 'white'
        }}
      >
        {this.renderHeader()}
        <View style={{ display: tab === 'chat' ? 'flex' : 'none', flex: 1, position: 'relative' }}>
          <Chat
            treatmentsModel={treatmentsModel}
            onInputMsgFocus={(e) => {
              setTimeout(() => {
                e.target.scrollIntoView();
              }, 200);
            }}
          />
        </View>
        <View style={{ display: tab === 'analyses' ? 'flex' : 'none', flex: 1 }}>
          <AnalysesList model={analysesModel} />
        </View>
        <View style={{ display: tab === 'treatment' ? 'flex' : 'none', flex: 1 }}>
          <TreatmentsList model={treatmentsModel} showDoctor={true} />
        </View>
        <View style={{ display: tab === 'timeline' ? 'flex' : 'none', flex: 1 }}>
          <TimelineList
            selectJourney={timelineModel.selectJourney}
            journeys={
              timelineModel.listInput('journeys', timelineModel.state.partnerId + ':recent') || []
            }
            journey={timelineModel.listInput('journey', timelineModel.state.partnerId + ':recent')}
            journeyId={timelineModel.listInput(
              'journeyId',
              timelineModel.state.partnerId + ':recent'
            )}
            model={timelineModel}
          />
        </View>
      </View>
    );
  }
}

export const Message = withRouter(Main);
